export const ROUTES = {
    AUTH: '',
    LOGIN: '/login',
    SIGNUP: '/signup',
    RECIPE: '/recipe',
    ONBOARDING: '/onboarding',
    CANVAS_DASHBOARD: '/canvas',
    CANVAS: '/canvas/:canvasID',
    EXPLORER: '/explorer',
    EXPLORERV2: '/explorerV2',
    INSIGHTS: '/insights',
    ASSET: '/asset',
    SUMMARY_ASSET: 'chart',
    CLUSTER_ASSET: 'cluster',
    TREE_ASSET: 'tree',
    SOURCES: '/sources',
    ACCOUNT: '/account',
    SOURCE: '/sources/:inboxID',
    LIVE_QUERY: '/live-query',
    ACCEPT_INVITATION: '/accept-invitation',
    LOGOUT: '/logout',
    GOOGLELOGIN: '/googlelogin',
    HUBSPOT: '/hubspot',
    APICONNECTORAUTH: '/apiconnectorauth',
    GMAIL: '/gmail',
    SALESFORCE: '/salesforce',
    LIVE_WORKSHEETS: '/live-worksheets',
    SETUP: '/setup',
    SCOOPADMIN: '/scoopadmin',
    PRESENTATION: '/canvas/:canvasId/presentation/:slideId',
    CHAT: '/chat',
    DEMO_CHAT: '/demo-chat',
    DEMO_CHAT_OPPORTUNITIES: '/demo-chat/opportunities',
    DEMO_CHAT_HOUSING: '/demo-chat/housing',
    EMBEDDED_CHAT: '/embedded-chat',
    BILLING_SUCCESS: '/billing/success',
    BILLING_CANCEL: '/billing/cancel',
    DOMAIN_INTELLIGENCE: '/domain-intelligence',
    DI_DESIGN_GALLERY: '/di-design-gallery',
}
